export const WEB_TO_LEARN_COLOR = '#6635EF'
export const THRIVE_COACH_COLOR = '#2F7FED'
export const SPECTRUM_MARKETING_COLOR = '#FFB301'

export const WEB_TO_LEARN = 'webtolearn'
export const THRIVE_COACH = 'thrivecoach'
export const SPECTRUM_MARKETING = 'spectrum'
